<template>
<div class="chapter">
<div class="inner_page">
<div class="dedicationPage">
<a id="title47"></a>
<div class="p-c-br"><span><em class="i">To my much-loved friends in New Orleans and<br/> southeast Louisiana, who’ve endured so much and yet<br/> live so large, no matter what life throws your way</em></span></div></div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// e9781429988476_ded01.vue?de2fbdf6